module.exports = __webpack_public_path__ + "img/img_web04_pic1@2x.95e6fd44.png";